// src/Models/iconMapper.ts
import {
  SettingOutlined,
  UserOutlined,
  TeamOutlined,
  GlobalOutlined,
  HomeOutlined,
  FileDoneOutlined,
  FileSearchOutlined,
  EditOutlined,
  CheckCircleOutlined,
  BankOutlined,
  FileProtectOutlined,
  ApartmentOutlined,
  LockOutlined,
  UnlockOutlined,
  BarChartOutlined,
  CalendarOutlined,
  CopyOutlined,
  SolutionOutlined,
  IdcardOutlined,
  EnvironmentOutlined,
  NodeExpandOutlined,
  FileTextOutlined,
  FileExcelOutlined,
  WalletOutlined,
  BookOutlined,
  ScheduleOutlined,
  ClusterOutlined,
  FundOutlined,
  RiseOutlined,
  FallOutlined,
  SwapOutlined,
  FileSyncOutlined,
  PlusCircleOutlined,
  MinusCircleOutlined,
  FileAddOutlined,
  FileExclamationOutlined,
  FolderOpenOutlined,
  ContactsOutlined,
  PieChartOutlined,
  GroupOutlined,
  GoldOutlined,
  HourglassOutlined,
  ReloadOutlined,
} from '@ant-design/icons';
import {
  Settings,
  Login,
  Logout,
  AccountBalance,
  Timeline,
  Calculate,
  ReceiptLong,
  RestartAlt,
  SwapHoriz,
  Equalizer,
  Tune,
  Business,
  Person,
  PersonOutline,
  PeopleAlt,
  Public,
  Map,
  LocationCity,
  Apartment,
  Home,
  PublicOff,
  Warning,
  AccessTime,
  Work,
  School,
  CorporateFare,
  Favorite,
  Gavel,
  Engineering,
  GroupWork,
  Title,
  EmojiPeople,
  Category,
  Wc,
  FamilyRestroom,
  AccountTree,
  AttachMoney,
  GridView,
  Rule,
  DateRange,
  AccountBalanceWallet,
  Assignment,
  Schedule,
  CheckCircle,
  SupervisorAccount,
  DirectionsRun,
  RoomService,
  PointOfSale,
  Build,
  IntegrationInstructions,
  EventBusy,
  CreditCard,
  Dashboard,
  Receipt,
  TrendingDown,
  VerifiedUser,
  Description,
  Menu,
  Paid
} from '@mui/icons-material';


import {
 // Business,
 // Settings,
  FolderOpen,
  //SupervisorAccount,
  //PointOfSale,
  Assessment,
  BuildCircle,
} from '@mui/icons-material';

//import { EditOutlined } from '@ant-design/icons';


export const getIconForKey = (menuKey: string): React.ReactNode => {
  const map: Record<string, React.ReactNode> = {

  business: <Business style={{ fontSize: '20px',color: '#1976d2' }}/>,
  configuration: <Settings style={{ fontSize: '20px',color: '#9c27b0' }}/>,
  edition: <EditOutlined style={{ fontSize: '20px',color: '#f44336' }}/>,
  affichage: <EditOutlined style={{ fontSize: '20px',color: '#f44336' }}/>,
  fichier: <FolderOpen style={{ fontSize: '20px',color: '#ff9800' }}/>,
  gestion: <SupervisorAccount style={{ fontSize: '20px',color: '#4caf50' }}/>,
  opération: <PointOfSale style={{ fontSize: '20px',color: '#009688' }}/>,
  "rapports agence": <Assessment style={{ fontSize: '20px',color: '#3f51b5' }}/>,
  traitement: <BuildCircle style={{ fontSize: '20px', color: '#795548' }}/>,
  "Vue à 360": <FileProtectOutlined style={{ color:"primary" }}/>,
  financement: <Paid style={{ fontSize: '20px', color: '#089413' }}/>,

  //"business": <Settings />,
  "système": <Login style={{ color:"primary" }}/>,
  "ouverture": <Logout style={{ color:"primary" }}/>,
  "fermeture": <AccountBalance style={{ color:"primary" }}/>,
  "système caisse": <Timeline style={{ color:"primary" }}/>,
  Mensuel: <Calculate />,
  "control compte": <ReceiptLong style={{ color:"primary" }}/>,
  "echel individuel": <RestartAlt style={{ color:"primary" }}/>,
  "calcul agios": <SwapHoriz style={{ color:"primary" }}/>,
  "imputation agios": <Equalizer style={{ color:"primary" }}/>,
  "annuel": <Tune style={{ color:"primary" }}/>,
  "mise à zero compte": <Business style={{ color:"primary" }}/>,
  "transfert solde": <Person style={{ color:"primary" }}/>,
  "calcul resultat": <PersonOutline style={{ color:"primary" }}/>,
  //"configuration": <PeopleAlt />,
  "agence": <Public />,
  "profil utilisateur": <Map style={{ color:"primary" }}/>,
  "utilisateur": <LocationCity style={{ color:"primary" }}/>,
  "profil client": <Apartment style={{ color:"primary" }}/>,
  "pays": <Home style={{ color:"primary" }}/>,
  "région": <PublicOff style={{ color:"primary" }}/>,
  "ville": <Warning style={{ color:"primary" }}/>,
  "département": <AccessTime style={{ color:"primary" }}/>,
  "résidence": <Work style={{ color:"primary" }}/>,
  "zone géographique": <School style={{ color:"primary" }}/>,
  "classe risque": <CorporateFare style={{ color:"primary" }}/>,
  "calsse age": <Favorite style={{ color:"primary" }}/>,
  "activité": <Gavel style={{ color:"primary" }}/>,
  "niveau étude": <Engineering />,
  "classe institutionelle": <GroupWork />,
  "régime matrimonial": <Title />,
  "forme juridique": <EmojiPeople />,
  "profession": <Category />,
  "groupe client": <Wc />,
  "titre client": <FamilyRestroom />,
  "etnie": <AccountTree />,
  "type client": <AttachMoney />,
  "genre": <GridView />,
  "filiation": <Rule />,
  "profil gestion": <DateRange />,
  "plan comptable": <AccountBalanceWallet />,
  "commssions-interets": <Assignment />,
  "grille commission": <Schedule />,
  "code arreté": <CheckCircle />,
  "période comptable": <SupervisorAccount />,
  "type prêts": <DirectionsRun />,
  "objet prêts": <RoomService />,
  "durée prêts": <PointOfSale />,
  "libelle prêts": <Build />,
  "etat compte": <IntegrationInstructions />,
  "gestionnaire": <EventBusy />,
  "démarcheur": <CreditCard />,
  "service": <Dashboard />,
  "devise": <Receipt />,
  "banque": <TrendingDown />,
  "caisse": <VerifiedUser />,
  "operation système": <Description />,
  "interface compte gl": <Menu />,
  "jour férier": <SettingOutlined />,
  "type compte": <UserOutlined />,
  "catégorie compte": <TeamOutlined />,
  "bon de caisse": <GlobalOutlined />,
  "decouvert": <HomeOutlined />,
  "garantie": <FileDoneOutlined />,
  "document": <FileSearchOutlined />,
  "chèque": <EditOutlined />,
  //"edition": <CheckCircleOutlined />,
  "transanctions": <BankOutlined />,
  "historique compte": <FileProtectOutlined />,
  "brouillard caisse": <ApartmentOutlined />,
  "brouillard backoffice": <LockOutlined />,
  "comptabilisées": <UnlockOutlined />,
 // "fichier": <BarChartOutlined />,
  "connexion": <CalendarOutlined />,
  "déonnexion": <CopyOutlined />,
  "mot de pass": <SolutionOutlined />,
  "changer agence": <IdcardOutlined />,
  //"gestion": <EnvironmentOutlined />,
  "client": <NodeExpandOutlined />,
  "physique": <FileTextOutlined />,
  "validation physique": <FileExcelOutlined />,
  "moral": <WalletOutlined />,
  "validation moral": <BookOutlined />,
  "grand livre": <ScheduleOutlined />,
  "validation gl": <ClusterOutlined />,
  "cloture": <FundOutlined />,
  "validation cloture": <RiseOutlined />,
  "visualisation cloture": <FallOutlined />,
  "relation": <SwapOutlined />,
  "creation": <FileSyncOutlined />,
  "validation": <PlusCircleOutlined />,
  "visualisation": <MinusCircleOutlined />,
  "procuration": <SwapOutlined />,
  "ayant droit": <FileExclamationOutlined />,
  "demande": <FolderOpenOutlined />,
  "compte": <ContactsOutlined />,
  "engagement": <PieChartOutlined />,
  "condition spéciale": <GroupOutlined />,
  "chéquier": <GoldOutlined />,
  //"opération": <HourglassOutlined />,
  //"visualisation cloture": <ReloadOutlined />
    // // Business / Système
    // business: <BarChartOutlined />,
    // systeme: <SettingOutlined />,
    // configuration: <SettingOutlined />,

    // // Agence et utilisateurs
    // agence: <BankOutlined />,
    // utilisateur: <UserOutlined />,
    // profilutilisateur: <TeamOutlined />,
    // profilclient: <IdcardOutlined />,
    // groupe: <GroupOutlined />,

    // // Localisation & client
    // pays: <GlobalOutlined />,
    // region: <EnvironmentOutlined />,
    // ville: <HomeOutlined />,
    // departement: <ApartmentOutlined />,
    // residence: <HomeOutlined />,
    // zonegeographique: <NodeExpandOutlined />,
    // classerisque: <FileExclamationOutlined />,
    // classeage: <ScheduleOutlined />,
    // activite: <FundOutlined />,
    // niveauetude: <BookOutlined />,
    // classeinstitutionelle: <ClusterOutlined />,
    // regimematrimonial: <FileProtectOutlined />,
    // formejuridique: <FileProtectOutlined />,
    // profession: <SolutionOutlined />,
    // groupeclient: <TeamOutlined />,
    // titreclient: <IdcardOutlined />,
    // etnie: <ContactsOutlined />,
    // typeclient: <IdcardOutlined />,
    // genre: <UserOutlined />,
    // filiation: <UserOutlined />,

    // // Profil gestion
    // plancomptable: <FileTextOutlined />,
    // commssionsinterets: <WalletOutlined />,
    // grillecommission: <PieChartOutlined />,
    // codearreté: <FileDoneOutlined />,
    // periodecomptable: <CalendarOutlined />,
    // typeprets: <RiseOutlined />,
    // objetprets: <FundOutlined />,
    // dureeprets: <HourglassOutlined />,
    // libelleprets: <FileAddOutlined />,
    // etatcompte: <CheckCircleOutlined />,
    // gestionnaire: <UserOutlined />,
    // demarcheur: <UserOutlined />,
    // service: <SolutionOutlined />,
    // devise: <GoldOutlined />,
    // banque: <BankOutlined />,
    // caisse: <WalletOutlined />,
    // operationsysteme: <EditOutlined />,
    // interfacecomptegl: <SwapOutlined />,
    // jourferier: <CalendarOutlined />,
    // typecompte: <CopyOutlined />,
    // categoriecompte: <CopyOutlined />,
    // bondecaisse: <FileTextOutlined />,
    // decouvert: <MinusCircleOutlined />,
    // garantie: <FileProtectOutlined />,
    // document: <FileTextOutlined />,
    // cheque: <FileSyncOutlined />,
    // edition: <FileDoneOutlined />,
    // transactions: <FileSearchOutlined />,

    // // Gestion client
    // client: <UserOutlined />,
    // physique: <UserOutlined />,
    // validationphysique: <CheckCircleOutlined />,
    // moral: <TeamOutlined />,
    // validationmoral: <CheckCircleOutlined />,
    // grandlivre: <BookOutlined />,
    // validationgl: <CheckCircleOutlined />,

    // // Clôture
    // cloture: <LockOutlined />,
    // validationcloture: <CheckCircleOutlined />,
    // visualisationcloture: <FileSearchOutlined />,

    // // Relation
    // relation: <TeamOutlined />,
    // creation: <FileAddOutlined />,
    // validation: <CheckCircleOutlined />,
    // visualisation: <FileSearchOutlined />,

    // // Procuration, ayant droit, document
    // procuration: <FileProtectOutlined />,
    // ayantdroit: <UserOutlined />,

    // // Compte
    // compte: <WalletOutlined />,
    // operation: <EditOutlined />,
    // engagement: <LockOutlined />,
    // conditionspeciale: <FileProtectOutlined />,

    // // Chéquier
    // chequier: <FileTextOutlined />,
    // demande: <FileAddOutlined />,
    // miseenplace: <FileDoneOutlined />,
    // validationoposition: <CheckCircleOutlined />,
    // annulationoposition: <ReloadOutlined />,
    // opposition: <FileExclamationOutlined />,

    // // Limite tirage
    // limitetirage: <MinusCircleOutlined />,

    // // Virement
    // virementpermenante: <SwapOutlined />,

    // // Gel
    // geldecompte: <LockOutlined />,

    // // Prêts
    // prets: <FundOutlined />,
    // simulation: <PieChartOutlined />,
    // proposition: <FileDoneOutlined />,
    // decaissement: <FallOutlined />,
    // anticipation: <RiseOutlined />,
    // periodegrace: <HourglassOutlined />,
    // interruption: <MinusCircleOutlined />,
    // reechelonnement: <SwapOutlined />,
    // refinancement: <RiseOutlined />,
    // declassement: <FallOutlined />,
    // radiation: <LockOutlined />,

    // // Operation caisse
    // caisseoperation: <WalletOutlined />,
    // ouverturefermeture: <UnlockOutlined />,
    // veresmentretrait: <SwapOutlined />,
    // echangemanuel: <SwapOutlined />,
    // intercaisse: <SwapOutlined />,
    // interbanque: <SwapOutlined />,
    // arrete: <LockOutlined />,

    // // Back office
    // backoffice: <FileDoneOutlined />,
    // creationbo: <FileAddOutlined />,
    // extourne: <ReloadOutlined />,
    // validationbo: <CheckCircleOutlined />,
    // importationexcel: <FileExcelOutlined />,
    // saisieanterieur: <FileTextOutlined />,
    // virementcompteacompte: <SwapOutlined />,

    // // Rapports
     rapports: <BarChartOutlined />,
     "module clients": <UserOutlined />,
     "module compte": <WalletOutlined />,
     "module transactions": <FileSearchOutlined />,
     "modul eprets": <FundOutlined />,
     "module finance": <BarChartOutlined />,
     "module audit": <FileProtectOutlined />,
     "module cobac": <SolutionOutlined />,

    // // Connexion / sécurité
    // connexion: <UnlockOutlined />,
    // deconnexion: <LockOutlined />,
    // //'mot de pass': <Key />,
    // changeragence: <SwapOutlined />,
  };

  return map[menuKey.toLowerCase()] || <FileDoneOutlined />;
};
